<link rel="stylesheet"
    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0" />
<app-generic-loader [isLoader]="isLoading"></app-generic-loader>
<app-header-nav-bar style="--nav-header-img: url('/assets/images/common/Header.svg')">
    <app-header-nav-text-snapshot [isAddClientDetails]="true"></app-header-nav-text-snapshot>
    <app-header-home [moduleName]="'snapshot'"></app-header-home>
</app-header-nav-bar>
<div class="snapshot_configuration_container">
    <div class="SnapshotClientNameArea" >
        <div class="client-name">Client Dashboard</div>
        <div class="client-name-area"> Client Name</div>
    </div>

    <div class="snapshot_selection">
        <div class="snapshot-button-area"></div>
        <div class="snapshot-tab-area">            
            <div class="snapshot-tabs-container">
            <div class="snapshot-create-btn addsnapshot"
                [style]="isAddsnapshotclicked?'color: white;background: linear-gradient(90deg, #8600CD 0%, #1110EB 100%);':'color: black;background-Color:white;'"
                title="Add Snapshot" (click)="addSnapshot()">
                <div class="btn-icon">
                    <span class="add" style="display: flex;">
                        <img
                            [src]="!isAddsnapshotclicked?'assets/images/common/Add.svg':'assets/images/common/Add_hover.svg'">
                    </span>
                </div>
                <div class="btn-text">Add Snapshot</div>
            </div>
            <div *ngFor="let studynames of visibleSnapshots; let i = index"
                [style]="studynames.selected?'color: white;background: linear-gradient(90deg, #8600CD 0%, #1110EB 100%);':'color: black;background-Color:white;'"
                class="snapshot-create-btn" [title]="studynames.studyname" (click)="selectedStudy(studynames, i)">
                <div class="btn-icon"
                    [style]="studynames.selected?'color: white;background-Color:#8029B6;':'color: #8029B6;background-Color:white;'">
                    <!-- <span class="material-symbols-outlined">
                    dashboard_customize
                </span> -->
                    <span style="display: flex;"><img
                            [src]="studynames.selected?'assets/ImagesSnapshot/Public/snapshot_icon_white.svg':'assets/ImagesSnapshot/Public/snapshot_icon_purpl.svg'"></span>
                </div>
                <div class="btn-text">{{ studynames.studyname }}</div>
                <!-- <span class="material-symbols-outlined">
                more_vert
            </span> -->
            </div>
            </div>
            <button class="tile-arrow left" 
                [style.opacity]="canShowPrevSnapshot ? '1' : '0.5'"
                [style.cursor]="canShowPrevSnapshot ? 'pointer' : 'not-allowed'"
                [disabled]="!canShowPrevSnapshot"
                (click)="showPrevSnapshot()">
            <img src="assets/images/arrowslefticon.png"/>
            </button>
            <button class="tile-arrow right" 
                [style.opacity]="canShowNextSnapshot ? '1' : '0.5'"
                [style.cursor]="canShowNextSnapshot ? 'pointer' : 'not-allowed'"
                [disabled]="!canShowNextSnapshot"
                (click)="showNextSnapshot()">
            <img src="assets/images/arrowsrighticon.png"/>
        </button>
        </div>

    </div>
    <div class="snapshot_configuration_tabs" *ngIf="snapshotShow">
        <!-- [style]="!showModuleConfigCondition?'backgroundColor =#ffffff;style.color = #000000':'backgroundColor =#802AB7;style.color = #ffffff'"  -->
        <div class="general_configuaration"
            [class.disabled]="!istemplateselected"
            [style]="(!showModuleConfigCondition?'background-Color:#ffffff;color:#000000':'background-Color:#802AB7;color:#ffffff')"
            (click)="showModuleConfig()">
            Module Configuration
        </div>
        <!-- [style]="showWidgetLibraryCondition?'backgroundColor =#ffffff;style.color = #000000':'backgroundColor =#802AB7;style.color = #ffffff'" -->
        <div class="widget_library" [class.disabled]="enableWidgetLibrarySection"
        [style]="!_configService.ifDataExists?'opacity: 0.5;pointer-events: none;':(!showWidgetLibraryCondition?'background-Color:#ffffff;color: #000000':'background-Color:#802AB7;color: #ffffff')"
        (click)="_configService.ifDataExists?showWidgetLibrary():''">
            Widget Library
        </div>
        <div class="additional_Config" *ngIf="productSelectedValue=='custom'" [class.disabled]="enableAdditonalConfig && enableWidgetLibrarySection"
        [style]="!_configService.ifDataExists?'opacity: 0.5;pointer-events: none;':(!showAdditonalConfigCondition?'background-Color:#ffffff;color: #000000':'background-Color:#802AB7;color: #ffffff')"
        (click)="_configService.ifDataExists?showAdditonalConfig():''">
            Additional Configuration
        </div>


        <div class="dropdown-container" *ngIf="!hideProductDropdown || !hideTemplateDropdown">

            <!-- *ngFor="let option of options" [value]="option.value" -->
            <div class="productdropdown" *ngIf="!hideProductDropdown">
                <label for="myDropdown">Product</label>
                <select id="myDropdown product" [class.disabled]="isExisting" (change)="productSelected($event)" [ngModel]="productSelectedValue">
                    <!-- <option value="" disabled selected>Select</option> -->
                    <option *ngFor="let option of product" [value]="option.value">{{option.name}}</option>
                </select>
            </div>
            <div class="templatedropdown" [class.disabled]="!isStandardProduct" *ngIf="!hideTemplateDropdown">
                <label for="myDropdown">Template</label>
                <select id="myDropdown template" [class.disabled]="isExisting" (change)="templateSelected($event)" #templatedropdown [(ngModel)]="templateSelectedValue">
                    <option value="select" disabled selected>Select</option>
                    <option *ngFor="let option of template" [value]="option.value">{{option.name}}</option>
                </select>
            </div>

        </div>
    </div>
    <div class="snapshot_configuaration_body">
        <app-moduleconfiguration [id]="snapID" [selectedSnapshotData]="selectedSnapshot"
            [currentSnapshotList]="clientSnapshotNames" [clientStudyData]="clientStudyApiData" style="width: 100%;" (alreadyExisting)="setexistingFlag($event)"  (isSubmitted)="enableWidegtLibrary($event)"
            *ngIf="showModuleConfigCondition && !showWidgetLibraryCondition"></app-moduleconfiguration>
        <!-- <app-widget-library (isSubmitted)="handleSubmission($event)" [selectedSnapshotData]="selectedSnapshot"
            style="width: 100%;" *ngIf="showWidgetLibraryCondition"></app-widget-library> -->
            <app-standard-widget-library style="width:100%" *ngIf="showWidgetLibraryCondition && productSelectedValue=='standard'"></app-standard-widget-library>
            <app-widget-library [clientStudyData]="clientStudyApiData" style="width:100%" *ngIf="showWidgetLibraryCondition && productSelectedValue=='custom'"></app-widget-library>
            <app-custom-metric-widgetlibrary [handleNumeralPopUPeventdata]="handleNumeralPopUPeventdata" [addnumeraleventdata]="addnumeraleventdata"  (isNumeralEvent)="handleNumeralChange($event)" (showLoaderEvent)="handleLoader($event)"  style="width:100%" *ngIf="showAdditonalConfigCondition && productSelectedValue=='custom'"></app-custom-metric-widgetlibrary>
    </div>
</div>
<app-shared-popup *ngIf="isNumeral" [isNumeral]="isNumeral" [showLoaderPopUp]="showLoaderPopUp"
                (isSavePopUpVisible)="handleNumeralPopUP($event)"
                (bindNumeralSave)="addNumeral($event)"></app-shared-popup>


<!-- <div class="widget_library" [class.disabled]="enableWidgetLibrarySection"
            [style]="!_configService.ifDataExists?'opacity: 0.5;pointer-events: none;':(!showWidgetLibraryCondition?'background-Color:#ffffff;color: #000000':'background-Color:#802AB7;color: #ffffff')"
            (click)="_configService.ifDataExists?showWidgetLibrary():''">
            Widget Library
        </div> -->
<!-- <div class="widget_library" [class.disabled]="enableWidgetLibrarySection"
        [style]="(!showWidgetLibraryCondition?'background-Color:#ffffff;color:#000000':'background-Color:#802AB7;color:#ffffff')"
            (click)="showWidgetLibrary()">
            Widget Library
        </div> -->
